/* unplugin-vue-components disabled */import script from "./ScreenScrollView.vue?vue&type=script&lang=tsx&setup=true&generic=T%20extends%20object"
export * from "./ScreenScrollView.vue?vue&type=script&lang=tsx&setup=true&generic=T%20extends%20object"

import "./ScreenScrollView.vue?vue&type=style&index=0&id=54f90e91&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54f90e91"]])

export default __exports__